import vailcode from "@utils/errcode";
const confetti = require("@assets/js/confetti.js");
import { createNamespacedHelpers } from "vuex";
const taskVuex = createNamespacedHelpers("task");
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
const assetsVuex = createNamespacedHelpers("assets");
export default {
  name: "mpay",
  computed: {
    ...taskVuex.mapState(["mpayTaskInfo"]),
    ...walletVuex.mapState(["isMobile", "theme", "setting"]),
    ...userVuex.mapState(["userData"]),
    ...assetsVuex.mapState(["assetsList"]),
    confetti() {
      return confetti;
    },
    sortedMpayRewardTotal() {
      const entries = Object.entries(this.mpayRewardTotal);
      // 把 Settlement 放到最前
      entries.sort(([k1, v1], [k2, v2]) => {
        if (v1.title === "Settlement") return -1;
        if (v2.title === "Settlement") return 1;
        return 0;
      });
      return Object.fromEntries(entries);
    },
    showBtnClaimReward() {
      return this.mpayTaskInfo?.taskInfo?.completed || this.mpayRewardTotal["unclaimed"].logsTotal || this.mpayRewardTotal["settlement"].logsTotal || this.mpayRewardTotal["claimed"].logsTotal;
    }
  },
  data() {
    return {
      popMpayInviteShow: false,
      firendInviteList: [],
      firendList: [],
      firendListPage: {
        page: 1,
        limit: 100,
        isLoading: false,
        totalPages: 1
      },
      popRewardShow: false,
      isClaimLoading: false,
      // mpayTaskInfo: {
      //   completed: false,
      // },
      taskError: {
        code: null,
        message: null
      },
      isInviteLoading: false,
      isReward: false,
      firstApplyCard: true,
      popMpayDetailShow: false,
      popApplyCardRewardShow: false,
      popMpayTotalRewardInfoShow: false,
      mpayRewardTotalPage: {
        limit: 200,
        page: 1
      },
      mpayRewardTotal: {
        unclaimed: {
          reward: [{
            total: 0,
            currency: "ton",
            symbol: "USDT"
          }, {
            total: 0,
            currency: "stock",
            symbol: "stock"
          }],
          status: 0,
          title: "To be Claimed",
          key: "unclaimed",
          logs: [],
          logsTotal: 0
        },
        settlement: {
          reward: [{
            total: 0,
            currency: "ton",
            symbol: "USDT"
          }, {
            total: 0,
            currency: "stock",
            symbol: "stock"
          }],
          status: -1,
          title: "Settlement",
          key: "settlement",
          logs: [],
          logsTotal: 0
        },
        claimed: {
          reward: [{
            total: 0,
            currency: "ton",
            symbol: "USDT"
          }, {
            total: 0,
            currency: "stock",
            symbol: "stock"
          }],
          status: 1,
          title: "Claimed",
          key: "claimed",
          logs: [],
          logsTotal: 0
        }
      },
      selectLogsType: {
        status: -1,
        key: "settlement"
      },
      isManualClaimLoading: false,
      mpayRewardResult: null,
      mpayclaimResult: null,
      isRefresh: false
    };
  },
  watch: {
    "selectLogsType.status": {
      handler(val) {
        if (val !== undefined || val !== null) {
          console.log("213123", val);
        }
      },
      deep: true,
      immediate: true
    },
    popRewardShow(bool) {
      if (!bool) {
        if (JSON.stringify(this.mpayclaimResult) != "{}") {
          let data = this.mpayclaimResult;
          if (data.unclaimed && data.unclaimed.length) {
            this.mpayRewardTotal["unclaimed"].reward = data.unclaimed;
          } else {
            this.mpayRewardTotal["unclaimed"].reward = [{
              total: 0,
              currency: "ton",
              symbol: "USDT"
            }, {
              total: 0,
              currency: "stock",
              symbol: "stock"
            }];
          }
          if (data.settlement && data.settlement.length) {
            this.mpayRewardTotal["settlement"].reward = data.settlement;
          } else {
            this.mpayRewardTotal["settlement"].reward = [{
              total: 0,
              currency: "ton",
              symbol: "USDT"
            }, {
              total: 0,
              currency: "stock",
              symbol: "stock"
            }];
          }
          if (data.claimed && data.claimed.length) {
            this.mpayRewardTotal["claimed"].reward = data.claimed;
          } else {
            this.mpayRewardTotal["claimed"].reward = [{
              total: 0,
              currency: "ton",
              symbol: "USDT"
            }, {
              total: 0,
              currency: "stock",
              symbol: "stock"
            }];
          }
        }
        this.mpayRewardResult = null;
      }
    }
  },
  methods: {
    ...userVuex.mapMutations(["setUserData"]),
    ...taskVuex.mapActions(["getTaskMpayInfo"]),
    ...assetsVuex.mapActions(["getAssetsList"]),
    async onRefresh() {
      if (this.isRefresh) return;
      this.isRefresh = true;
      try {
        await this.getFirendInviteList();
        await this.getMpayAwardTotal();
        await this.getMpayAwardLogs();
      } catch (err) {}
      setTimeout(() => {
        console.log(444);
        this.isRefresh = false;
        this.$toasted.success("Refresh success!");
      }, 3000);
    },
    showHistory() {
      this.popMpayInviteShow = true;
      this.$nextTick(async () => {
        if (!this.firendList) {
          await this.getFirendList();
        }
      });
    },
    async getFirendInviteList() {
      const res = await _v.$http.post("/mpay/logs", {});
      return new Promise(resolve => {
        vailcode(res, () => {
          const items = res.data;
          this.firendInviteList = items;
          resolve(items);
        }, () => {
          resolve([]);
        });
      });
    },
    // async getFirendList(page = 1, limit = 10) {
    //   this.firendListPage.isLoading = true;
    //   // const res = await _v.$http.post("/mpay/logs", { page, limit });
    //   const res = await _v.$http.post("/mpay/logs", {});

    //   return new Promise((resolve) => {
    //     vailcode(
    //       res,
    //       () => {
    //         const items = res.data;
    //         console.log("itemsitemsitems", items);
    //         if (page === 1) {
    //           this.firendList = items;
    //         } else {
    //           this.firendList.push(...items);
    //         }
    //         this.firendListPage.totalPages = res.data.lastPage;
    //         this.firendListPage.page = page;
    //         this.firendListPage.isLoading = false;
    //         resolve(items);
    //       },
    //       () => {
    //         this.firendListPage.isLoading = false;
    //         resolve([]);
    //       }
    //     );
    //   });
    // },
    // firendListAddEventListenerScroll() {
    //   this.$nextTick(async () => {
    //     const container = this.$refs.popMpayinviteRef;
    //     setTimeout(async () => {
    //       await this.getFirendList(1, this.firendListPage.limit);
    //       if (container) {
    //         container.onscroll = this.firendListHandleScroll;
    //       }
    //     }, 200);
    //   });
    // },
    // async firendListHandleScroll(e) {
    //   const el = e.target;
    //   if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10 && !this.firendListPage.isLoading && this.firendListPage.page < this.firendListPage.totalPages) {
    //     this.getFirendList(this.firendListPage.page + 1, this.firendListPage.limit);
    //   }
    // },

    onApply() {
      let domain = null;
      const VUE_APP_MODE = process.env.VUE_APP_MODE;
      if (VUE_APP_MODE === "dev-prod" || VUE_APP_MODE === "prod") {
        domain = "MpayCardBot";
      } else {
        domain = "TTTMPay_bot";
      }
      const url = `https://t.me/${domain}/?startapp=ref_seen6ms`;
      this.WebApp.openTelegramLink(url);
    },
    setConfetti() {
      this.confetti({
        particleCount: 20,
        angle: 60,
        spread: 55,
        origin: {
          x: 0
        }
      });
      this.confetti({
        particleCount: 20,
        angle: 120,
        spread: 55,
        origin: {
          x: 1
        }
      });
    },
    async onClaim() {
      this.firstApplyCard = false;
      this.taskError.code = null;
      this.taskError.message = null;
      if (this.isClaimLoading) return;
      this.isClaimLoading = true;
      const res = await this.claimFnc();
      if (!res) {
        this.isClaimLoading = false;
        return;
      }
      this.isClaimLoading = false;
      this.popApplyCardRewardShow = true;
      this.$nextTick(() => {
        this.setConfetti();
        setTimeout(async () => {
          this.mpayTaskInfo.taskInfo.completed = res.taskInfo.completed;
          await this.getMpayAwardTotal();
          await this.getMpayAwardLogs();
        }, 1000);
      });
    },
    async claimFnc() {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/mpay/check", {});
        if (!res) {
          this.isClaimLoading = false;
          resolve();
          return;
        }
        if (res.code != 0) {
          this.taskError.code = res.code;
          this.taskError.message = res.message;
          this.isClaimLoading = false;
          this.onApply();
          resolve();
          return;
        }
        const data = res.data;
        if (!data) {
          this.isClaimLoading = false;
          resolve();
          return;
        }
        this.isClaimLoading = false;
        this.taskError.code = null;
        this.taskError.message = null;
        resolve(data);
      });
    },
    getInviteMsgId() {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/mpay/preinlinemessage", {});
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            this.isInviteLoading = false;
            resolve();
            return;
          }
          this.isInviteLoading = false;
          resolve(data.id);
        }, () => {
          resolve();
        });
      });
    },
    async onInvite() {
      if (this.isInviteLoading) return;
      this.isInviteLoading = true;
      console.log("this.WebApp", this.WebApp);
      // const msgId = await this.getInviteMsgId();
      // if (!msgId) {
      //   this.$toasted.error("Invite error!");
      //   this.isInviteLoading = false;
      //   return;
      // }
      // try {
      //   if (this.WebApp?.shareMessage) {
      //     this.WebApp.shareMessage(msgId, (success) => {
      //       this.isInviteLoading = false;
      //       if (success) {
      //         this.$toasted.success("Share success!");
      //       }
      //     });
      //   }
      // } catch (err) {
      // }
      const linkname = "Come and claim your 1 million USDT!\n";
      let url = `https://t.me/share/url?text=${encodeURIComponent(linkname)}&url=https://t.me/${this.setting.botname}/app?startapp=ref_${this.userData.ref_code}-page_mpay`;
      this.isInviteLoading = false;
      this.WebApp.openTelegramLink(url);
    },
    onPopRewardClose() {
      this.popRewardShow = false;
    },
    async getMpayAwardTotal() {
      const res = await _v.$http.post("/mpay/award/total", {});
      return new Promise(resolve => {
        vailcode(res, () => {
          const data = res.data;
          for (const key in data) {
            this.mpayRewardTotal[key].reward = [{
              total: 0,
              currency: "ton",
              symbol: "USDT"
            }, {
              total: 0,
              currency: "stock",
              symbol: "stock"
            }];
            if (data[key] && data[key].length) {
              this.mpayRewardTotal[key].reward = data[key];
            }
          }
          console.log("datadatadatadata", this.mpayRewardTotal);
          resolve(data);
        }, () => {
          resolve([]);
        });
      });
    },
    getMpayAwardLogs() {
      const https = async params => {
        return new Promise(async resolve => {
          const re = await _v.$http.post("/mpay/award/logs", {
            ...params,
            page: this.mpayRewardTotalPage.page,
            limit: this.mpayRewardTotalPage.limit
          });
          vailcode(re, () => {
            const data = re.data;
            resolve(data);
          }, () => {
            resolve([]);
          });
        });
      };
      return new Promise(async resolve => {
        const status = [-1, 0, 1];
        const res = await Promise.all(status.map(it => https({
          status: it
        })));
        this.mpayRewardTotal["settlement"].logs = res[0].items;
        this.mpayRewardTotal["settlement"].logsTotal = res[0].total;
        this.mpayRewardTotal["unclaimed"].logs = res[1].items;
        this.mpayRewardTotal["unclaimed"].logsTotal = res[1].total;
        this.mpayRewardTotal["claimed"].logs = res[2].items;
        this.mpayRewardTotal["claimed"].logsTotal = res[2].total;
        console.log(" this.mpayRewardTotal", this.mpayRewardTotal);
        resolve();
      });
    },
    async getManualClaimReward() {
      this.isReward = false;
      if (this.isManualClaimLoading) return;
      this.isManualClaimLoading = true;
      const res = await _v.$http.post("/mpay/claim", {});
      return new Promise(resolve => {
        vailcode(res, () => {
          const data = res.data;
          this.mpayRewardResult = this.mpayRewardTotal["unclaimed"].reward;
          this.isManualClaimLoading = false;
          this.setConfetti();
          this.popRewardShow = true;
          this.$nextTick(async () => {
            this.mpayclaimResult = {
              unclaimed: data.unclaimed,
              settlement: data.settlement,
              claimed: data.claimed
            };
            await this.getMpayAwardLogs();
            setTimeout(async () => {
              await this.getAssetsList();
              this.setUserData(data.user_info);
              this.isReward = true;
            }, 1000);
          });
        }, () => {
          this.isManualClaimLoading = false;
          resolve([]);
        });
      });
    }
  },
  async mounted() {
    if (this.mpayTaskInfo.taskInfo) {
      await this.getTaskMpayInfo();
    }
    await this.getAssetsList();
    await this.getFirendInviteList();
    await this.getMpayAwardTotal();
    await this.getMpayAwardLogs();
    console.log("assetsList", this.assetsList);
  }
};